import { useEffect } from "react";
import type { Currency } from "@/lib/domain/Currency";
import type { PriceOverrideDetailsResponseModel as PriceOverrideDetailsModel } from "@/features/priceOverrides/api/usePriceOverrideDetails";
import { usePriceOverrideUpdate, type PriceOverrideUpdateRequestModel } from "@/features/priceOverrides/api/usePriceOverrideUpdate";

export const usePriceOverride = (
	value: number,
	currency: Currency,
	priceOverride: PriceOverrideDetailsModel
) => {

	const updatePriceOverride = usePriceOverrideUpdate();

	const performPriceOverrideUpdate = (requestModel: PriceOverrideUpdateRequestModel) => {
		updatePriceOverride.mutate(
			{
				requestModel: requestModel,
				priceOverrideId: priceOverride.priceOverrideId
			}
		);
	};

	useEffect(() => {
		if (isNaN(value)) {
			return;
		}

		if (value === priceOverride.price.value && currency === priceOverride.price.currency) {
			return;
		}

		const requestModel: PriceOverrideUpdateRequestModel = {
			price: {
				value: value,
				currency: currency
			}
		};

		const timer = setTimeout(() => performPriceOverrideUpdate(requestModel), 500);

		return () => clearTimeout(timer);
	}, [value, currency]);

	return updatePriceOverride;
};
